import React from "react";
import { useTranslation } from "react-i18next";
import { FiHelpCircle } from "react-icons/fi";

// Styles
import styles from "./Actions.module.scss";

// Types
import { Card } from "../../../types";
import Button from "../../button";
import LightBulb from "../../Svgs/LightBulb";

interface ActionsProps {
  card: Card | undefined;
  isFlipped?: boolean;
  currentStatus: Card['status'];
  handleFlip: () => void;
  handleNextCard: () => void;
}

const Actions: React.FC<ActionsProps> = ({ card, isFlipped, currentStatus, handleFlip, handleNextCard }) => {
  const { t } = useTranslation();

  const getStatusButtonClass = () => {
    const baseClass = styles.statusButton;
    const activeClass = currentStatus === card?.status ? styles.active : '';
    const statusClass = styles[card?.status || 'created'];

    return `${baseClass} ${statusClass} ${activeClass}`;
  };

  const getStatusCopy = () => {
    switch (card?.status) {
      case 'created':
        return t('flashcardReview.notLearned');
      case 'in_progress':
        return t('flashcardReview.inProgress');
      case 'learned':
        return t('flashcardReview.learned');
    }
  };

  const buildUrlFromCard = (card: Card, endpoint: 'correct' | 'incorrect') => {
    return `/cards/${card.id}/${endpoint}`;
  }

  const handleCorrect = () => {
    if (!card) return;
    const url = buildUrlFromCard(card, 'correct');
    fetch(url, {
      method: 'PATCH',
      headers: {
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') || '',
      }
    }).then(response => response.json()).then(data => {
    });
    handleNextCard()
  }

  const handleIncorrect = () => {
    if (!card) return;
    const url = buildUrlFromCard(card, 'incorrect');
    fetch(url, {
      method: 'PATCH',
      headers: {
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') || '',
      }
    }).then(response => response.json()).then(data => {
    });
    handleNextCard()
  }


  const flippedActions = (
    [
      <Button
        className={styles.correctButton}
        onClick={handleCorrect}>
        {t('flashcardReview.actions.correct')}
      </Button>,
      <Button
        className={styles.incorrectButton}
        onClick={handleIncorrect}>
        {t('flashcardReview.actions.incorrect')}
      </Button>
    ]
  )

  const unflippedActions = (
      <Button
        type="icon"
        className={`${styles.showAnswerButton} dark:bg-zeus-800`}
        onClick={handleFlip}
        icon={<LightBulb />}
      >
        {t('flashcardReview.actions.showAnswer')}
      </Button>
  )

  if (!card) {
    return null;
  }


  return (
    <div className="flex flex-row justify-between px-2 py-3 bg-white dark:bg-stone-650 bg-transparent rounded-b-2xl">
      <Button
        className={`${getStatusButtonClass()} dark:bg-white`}
        onClick={() => {}}
      >
        {getStatusCopy()}
      </Button>

      <div className="flex flex-row gap-2 w-full md:w-auto">
        {isFlipped ? flippedActions : unflippedActions}
      </div>
    </div>
  );
};

export default Actions;
